export default __webpack_public_path__ + "static/media/united.960c7bc6.png";